export const CREDIT_CARD_CONFLICT_DIALOG = {
  title: 'dialogs.credit_card_conflict.title',
  description: 'dialogs.credit_card_conflict.description',
  confirmButtonText: 'dialogs.credit_card_conflict.confirm_button',
  cancelButtonText: 'dialogs.credit_card_conflict.cancel_button',
  successMessage: 'dialogs.credit_card_conflict.success_message'
};

export const DEFAULT_SAVE_CHANGES_DIALOG = {
  title: 'dialogs.save_changes.title',
  description: 'dialogs.save_changes.description',
  confirmButtonText: 'dialogs.save_changes.confirm_button',
  cancelButtonText: 'dialogs.save_changes.cancel_button'
};
